import axios from 'axios';

export default class Request {
  constructor(options) {
    this.baseUrl = options.baseUrl;
    this.headers = options.headers || {};
    this.timeout = options.timeout || 3000;
    this._beforeRequest = options.beforeRequest;
    this._beforeRequestError = options.beforeRequestError;
    this._afterRequest = options.afterRequest;
    this._afterRequestError = options.afterRequestError;
    this.requestInstance = axios.create({
      baseURL: this.baseUrl,
      headers: this.headers,
      timeout: options.timeout || 30000,
    });
    this.requestInstance.interceptors.request.use(
      config => {
        if (!this._beforeRequest) return config;
        return this._beforeRequest(config);
      },
      error => {
        this._beforeRequestError && this._beforeRequestError(error);
        return Promise.reject(error);
      },
    );
    this.requestInstance.interceptors.response.use(
      res => {
        if (!this._afterRequest) return res;
        return this._afterRequest(res);
      },
      error => {
        this._afterRequestError && this._afterRequestError(error);
        return Promise.reject(error);
      }
    );
  }

  post(url, data, config) {
    return this.requestInstance.post(url, data, config);
  }

  get(url, config) {
    return this.requestInstance.get(url, config);
  }
}
